import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import SimpleBar from "simplebar-react";
import SidebarContent from "./SidebarContent";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCondensed: window.innerWidth <= 767,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({ isCondensed: window.innerWidth <= 767 });
  };

  render() {
    const { isCondensed } = this.state;

    const sidebarContainerStyle = isCondensed
      ? {
          position: "fixed",
          top: 0,
          bottom: 0,
          left: 0,
          width: "80px",
          zIndex: 999,
          backgroundColor: "#ffffff",
          transition: "all 0.2s ease-out",
          boxShadow: "0 0 20px rgba(0, 0, 0, 0.1)",
        }
      : {};

    return (
      <div className="vertical-menu" style={sidebarContainerStyle}>
        <div data-simplebar className="h-100" style={{ maxHeight: "100%" }}>
          {isCondensed ? (
            <SidebarContent />
          ) : (
            <SimpleBar style={{ maxHeight: "100%" }}>
              <SidebarContent />
            </SimpleBar>
          )}
        </div>
      </div>
    );
  }
}

const mapStatetoProps = (state) => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStatetoProps, {})(withRouter(Sidebar));
